module.exports = __webpack_public_path__ + "assets/img/img244.fa4dbd35.png";